<template>
  <ul>
    <div v-for="(item, num) in datas" :key="item.questionId">
      <div :class="[item.isMustAnswer ? 'title xh-exist' : 'title']">
       {{num + 1}}、 {{ item.questionTitle + (item.questionType == 1 ? "（多选）" : "") }}
      </div>
      <ul class="selection" :key="item.questionTitle" v-if="item.questionType < 3">
        <el-radio-group
          :value="item.userAnswer || ''"
          v-if="item.questionType == 0 || item.questionType == 2"
        >
          <li
            class="option"
            v-for="(option, index) in item.options"
            :key="option.optionId"
          >
            <el-radio el-radio :label="option.optionNo" disabled>{{
              String.fromCharCode(index + 65) + "." + option.optionTitle
            }}</el-radio>
          </li>
        </el-radio-group>
        <el-checkbox-group
          v-else-if="item.questionType == 1"
          :value="item.userAnswer || ''"
        >
          <li
            class="option"
            v-for="(option, index) in item.options"
            :key="option.optionId"
          >
            <el-checkbox :label="option.optionNo" disabled>{{
              String.fromCharCode(index + 65) + "." + option.optionTitle
            }}</el-checkbox>
          </li>
        </el-checkbox-group>
      </ul>
      <ul class="selection" :key="item.questionTitle" v-else>
        <el-input
          v-if="item.questionType == 3 || item.questionType == 4"
          :value="item.userAnswer || ''"
          type="textarea"
          :rows="3"
          placeholder="请输入内容"
          maxlength="1000"
          show-word-limit
          disabled
        ></el-input>
      </ul>
    </div>
  </ul>
</template>

<script>
export default {
  props: {
    datas: {
      type: Array,
      default: function() {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
$color: #343c4a;
@mixin text {
  color: $color;
  font-size: 14px;
}
ul {
  padding: 0 15px;
}
li {
  @include text;
}
.title {
  line-height: 42px;
  font-size: 1rem;
}
.xh-exist::before {
  content: '*';
  color: red;
  display: inline-block;
  margin-left: -11px;
}
.selection {
  padding-left: 0;
  margin-bottom: 10px;
  .option {
    list-style: none;
    padding: 5px 5px;
    // display: inline-block;
    margin-right: 10px;
    /deep/ .el-radio__label {
      display: inline-block;
      vertical-align: middle;
      @include text;
      font-weight: normal;
    }
    /deep/ .el-checkbox__label {
      @include text;
      font-weight: normal;
    }
    /deep/ .el-radio__input.is-disabled.is-checked .el-radio__inner {
      background-color: #3a85ff;
    }
    /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
      background-color: #3a85ff;
    }
  }
  /deep/ .el-textarea {
    padding: 10px 0 0 0;
    width: 70%;
  }
}
</style>
